import React, {forwardRef, useImperativeHandle} from 'react'
import { useAlert } from "@blaumaus/react-alert";

const Alert = forwardRef((props, ref) => {
  const alert = useAlert()

  useImperativeHandle(ref, () => ({
    sendAlert,
  }));

  const sendAlert = (message, type="error") => {
    const time = message.length > 50 ? 15000 : 3000;
    alert.show(message, {
      type,
      timeout: time,
    });
  }

  return (
    <div ref={ref} className="hidden"/>
  )
});

export default Alert;
